export default __webpack_public_path__ + "static/media/Course-Icons6.862295dd.svg";